const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  avatar: state => state.user.avatar,
  roleName: state => state.user.roleName,
  showPasswordHint: state => state.user.showPasswordHint,
  permissionCodeList: state => state.user.permissionCodeList,
  permission_routes: state => state.permission.routes,
  navTree: state => state.permission.navTree,
  menuRouteLoaded:  state=> state.user.menuRouteLoaded,
}
export default getters
